import { Auth } from 'aws-amplify';
import { set, get } from 'lodash';
import createAmplifyAPICallEpic from '../../redux/epics/utils';
import {
  createAPILifecycleActions,
  createAPILifecycleActionTypes,
} from '../../redux/actions/action_utils';
import { EXPORT_BULK_REPORT_ENDPOINT } from '../config/api_endpoints';

export const EXPORT_BULK_REPORT_ACTION_TYPES = createAPILifecycleActionTypes(
  'EXPORT_BULK_REPORT_ACTION_TYPES',
);
export const exportBulkReportAction = createAPILifecycleActions(
  EXPORT_BULK_REPORT_ACTION_TYPES.NAME,
);

const initialState = {
  isFetching: false,
  data: null,
  error: null,
};
export default (state = initialState, { type, payload }) => {
  switch (type) {
    case EXPORT_BULK_REPORT_ACTION_TYPES.BEGIN:
      return {
        ...state,
        isFetching: true,
      };
    case EXPORT_BULK_REPORT_ACTION_TYPES.SUCCESS:
      return {
        ...state,
        isFetching: false,
        data: payload,
        error: null,
      };
    case EXPORT_BULK_REPORT_ACTION_TYPES.FAILURE:
      return {
        ...state,
        isFetching: false,
        data: null,
        error: payload,
      };

    case EXPORT_BULK_REPORT_ACTION_TYPES.CLEAR:
      return initialState;
    default:
      return state;
  }
};
const addUserDetailsToPayload = async ({ originalPayload }) => {
  let newPayload = originalPayload;
  if (!newPayload) {
    newPayload = {};
  }
  const exportRequestAttributes = get((await Auth.currentSession()).getIdToken(), 'payload', {});
  set(newPayload, ['body', 'userEmail'], exportRequestAttributes.email);
  set(newPayload, ['body', 'user'], exportRequestAttributes.identities[0].userId);
  return newPayload;
};

export const exportBulkReportEpic = createAmplifyAPICallEpic({
  actionType: EXPORT_BULK_REPORT_ACTION_TYPES.BEGIN,
  api: EXPORT_BULK_REPORT_ENDPOINT,
  payloadGenerator: addUserDetailsToPayload,
  successCallback: response => [exportBulkReportAction.SUCCESS(response)],
  errorCallback: () => [exportBulkReportAction.FAILURE()],
});
